import trim from 'lodash/trim'
import uniq from 'lodash/uniq'

import { getFinanziamentoAssicurato } from './firmaUtils'

export const isPassaporto = documento =>
  documento === 'PASSAPORTO' || documento === 'Passaporto'
export const isCartaId = documento =>
  documento === 'CARTA_IDENTITA' || documento === 'CI'
export const isPatente = documento =>
  documento === 'PATENTE' || documento === 'Patente'
export const isPortoDarmi = documento => documento === 'PORTO_ARMI'
export const isTesseraMinisteriale = documento =>
  documento === 'TESSERA_MINISTERIALE'
export const isCartaIdElettr = documento =>
  documento === 'CARTA_IDENTITA_ELETTRONICA'
export const isPatenteElettr = documento => documento === 'PATENTE_ELETTRONICA'

export const residenzaPrecendenteRequired = findomesticDati => {
  if (!findomesticDati.residente_dal) {
    return false
  }

  if (!findomesticDati.residente_dal.year) {
    return false
  }

  const residenteDalYear = findomesticDati.residente_dal.year

  const currentYear = new Date().getFullYear()

  const yearDiff = currentYear - residenteDalYear
  return yearDiff <= 5
}

export const showSedeLavoro = (findomestic, coniuge = false) => {
  const __dati = findomestic.dati
  const __situazioneLavorativa = coniuge
    ? __dati.coniuge_situazione_lavorativa
    : __dati.situazione_lavorativa
  let _showSedeLavoro = __situazioneLavorativa !== ''

  const _occupazione = coniuge ? __dati.coniuge_occupazione : __dati.occupazione

  if (
    __situazioneLavorativa === 'Casalinga' ||
    __situazioneLavorativa === 'Senza occupazione/reddito' ||
    __situazioneLavorativa === 'Studente' ||
    __situazioneLavorativa === 'Pensionato' ||
    (_occupazione && _occupazione === 'Locatore')
  ) {
    _showSedeLavoro = false
  }

  return _showSedeLavoro
}

export const showDataInizioAttivita = (findomestic, coniuge = false) => {
  const ___dati = findomestic.dati
  const situazioneLavorativa = coniuge
    ? ___dati.coniuge_situazione_lavorativa
    : ___dati.situazione_lavorativa
  let _showDataInizioAttivita = situazioneLavorativa !== ''

  if (
    situazioneLavorativa === 'Casalinga' ||
    situazioneLavorativa === 'Senza occupazione/reddito' ||
    situazioneLavorativa === 'Studente'
  ) {
    _showDataInizioAttivita = false
  }

  return _showDataInizioAttivita
}

export const showDataScadenzaContratto = (findomestic, coniuge = false) => {
  const _dati = findomestic.dati
  const _situazioneLavorativa = coniuge
    ? _dati.coniuge_situazione_lavorativa
    : _dati.situazione_lavorativa
  let _showDataScadenzaContratto = _situazioneLavorativa !== ''

  const occupazione = coniuge ? _dati.coniuge_occupazione : _dati.occupazione

  const isSportivo =
    occupazione ===
      'Sportivo: calcio professionistico (dirigente, calciatore)' ||
    occupazione === 'Sportivo: altri sport professionistici'

  if (
    // BRUM-6826 per altri rediti non e' piu' obbligatorio
    //    _situazioneLavorativa === 'Altri Redditi' ||
    occupazione &&
    isSportivo
  ) {
    _showDataScadenzaContratto = true
  } else {
    _showDataScadenzaContratto = false
  }

  return _showDataScadenzaContratto
}

// si mostra sempre per adesso
export const showSituazioneLavorativa = () => true

export const isSituazioneLavorativaUniq = (findomestic, coniuge = false) => {
  const ____dati = findomestic.dati
  const sl = coniuge
    ? ____dati.coniuge_situazione_lavorativa
    : ____dati.situazione_lavorativa
  const selectedSett = coniuge ? ____dati.coniuge_settore : ____dati.settore

  if (
    Object.keys(findomestic.settoreBySituazione).length > 0 &&
    Object.keys(findomestic.occupazioneBySituazioneAndSettore).length > 0
  ) {
    let settori = findomestic.settoreBySituazione[sl].map(
      settore => settore.value
    )
    if (selectedSett) {
      settori = settori.filter(settore => settore === selectedSett)
    }
    // durante recupero carrello puo' succedere di non avere queste nello store
    const occupazioni = []
    settori.map(settore => {
      const situazioneAndSettore = `${sl}_${settore}`
      const _occupazioni =
        findomestic.occupazioneBySituazioneAndSettore[situazioneAndSettore]
      _occupazioni.map(occupazione => {
        occupazioni.push(occupazione.value)
        return false
      })
      return false
    })

    return uniq(occupazioni).length === 1 && uniq(settori).length === 1
  }
  return false
}

export const showOccupazione = (findomestic, coniuge = false) => {
  const _____dati = findomestic.dati
  const slAndSettSelected = coniuge
    ? _____dati.coniuge_situazione_lavorativa && _____dati.coniuge_settore
    : _____dati.situazione_lavorativa && _____dati.settore

  return slAndSettSelected && !isSituazioneLavorativaUniq(findomestic, coniuge)
}

export const showSettore = (findomestic, coniuge = false) => {
  let _showSettore = true
  const { dati } = findomestic
  const slSelected = !!(coniuge
    ? dati.coniuge_situazione_lavorativa
    : dati.situazione_lavorativa)

  if (Object.keys(findomestic.settoreBySituazione).length > 0) {
    if (slSelected) {
      const sl = coniuge
        ? dati.coniuge_situazione_lavorativa
        : dati.situazione_lavorativa

      if (!findomestic.settoreBySituazione[sl]) {
        _showSettore = false
      } else {
        const settori = findomestic.settoreBySituazione[sl].map(
          settore => settore.value
        )
        _showSettore = uniq(settori).length > 1
      }
    } else {
      // se non selezioni nessuna attivita' lavorativa non mostro settore
      _showSettore = false
    }
  } else {
    _showSettore = false
  }

  return _showSettore
}

export const showNumeroDocumento = () => false
export const showDataRilascioDocumento = () => false
export const showEnteDocumento = () => false
export const showScaricaPep = () => false

export const getSelectedFinanziamento = (ordine, financements) => {
  const idFinanziamento = ordine.id_finanziamento

  if (
    financements.custom !== null &&
    financements.custom.id_finanziamento === idFinanziamento
  ) {
    return financements.custom
  }

  const selectedFinanziamento = financements.default.filter(
    finanziamento => finanziamento.id_finanziamento === idFinanziamento
  )
  return selectedFinanziamento[0]
}

export const showDatiConiuge = findomestic => {
  const isSposato = findomestic.dati.stato_civile === 'SPOSATO'
  const isConvivente = findomestic.dati.stato_civile === 'CONVIVENTE'
  return isSposato || isConvivente
}

/**
 * BRUM-5881 per il coniuge e' obbligatorio il reddito
 */
export const showReddito = () => true

export const showCostoAbitazione = findomesticDati => {
  const situazioneAbitativa = findomesticDati.situazione_abitativa
  let _showCostoAbitazione = false
  if (
    trim(situazioneAbitativa) === 'AFFITTO' ||
    trim(situazioneAbitativa) === 'HOTEL' ||
    trim(situazioneAbitativa) === 'CON_MUTUO'
  ) {
    _showCostoAbitazione = true
  }

  return _showCostoAbitazione
}

export const showPaeseDiAttivita = (findomesticDati, coniuge = false) => {
  const occupazione = coniuge
    ? findomesticDati.coniuge_occupazione
    : findomesticDati.occupazione
  if (
    occupazione === 'Casalinga' ||
    occupazione === 'Locatore' ||
    occupazione === 'Pensionato'
  ) {
    return false
  }

  return true
}

export const showProfessionistiRischio = (findomestic, coniuge = false) => {
  const findomesticDati = findomestic.dati
  const settore = coniuge
    ? findomesticDati.coniuge_settore
    : findomesticDati.settore
  const situazioneLavorativa = coniuge
    ? findomesticDati.coniuge_situazione_lavorativa
    : findomesticDati.situazione_lavorativa
  const isARischio =
    settore && situazioneLavorativa
      ? getSettoriPerProfessionistiARischio(findomestic, coniuge).length > 1
      : false
  return isARischio
}

export const getSettoriPerProfessionistiARischio = (
  findomestic,
  coniuge = false
) => {
  let settori = []
  const mappaCodiciLavoroSettoriAttivita =
    findomestic.MappaCodiciLavoroSettoriAttivita
  const allCodiciSettoreAttivita = findomestic.CodiciSettoreAttivita
  const codiceTipoLavoro = getCodiceTipoLavoro(findomestic, coniuge)
  if (codiceTipoLavoro.length === 1) {
    const { codice } = codiceTipoLavoro[0]
    const codiciSettoriAttivita = mappaCodiciLavoroSettoriAttivita.reduce(
      (acc, clsa) => {
        if (clsa.codice_tipo_lavoro === codice) {
          acc.push(clsa)
        }

        return acc
      },
      []
    )

    if (codiciSettoriAttivita) {
      settori = allCodiciSettoreAttivita.reduce((acc, csa) => {
        const __ = codiciSettoriAttivita.filter(
          _ => _.codice_settore_attivita === csa.codice
        )
        if (__.length > 0) {
          acc.push(csa)
        }
        return acc
      }, [])
    }
  }

  return settori
}

export const getCodiceTipoLavoro = (findomestic, coniuge = false) => {
  const findomesticDati = findomestic.dati
  const situazioneLavorativa = trim(
    coniuge
      ? findomesticDati.coniuge_situazione_lavorativa
      : findomesticDati.situazione_lavorativa
  )
  const settoreKey = coniuge ? 'coniuge_settore' : 'settore'
  const settore = trim(
    findomesticDati[settoreKey] ||
      findomestic.settoreBySituazione[situazioneLavorativa][0].value
  )
  const occupazioneKey = coniuge ? 'coniuge_occupazione' : 'occupazione'
  let occupazioneBySituazioneAndSettore = ''

  if (findomestic.occupazioneBySituazioneAndSettore) {
    occupazioneBySituazioneAndSettore =
      findomestic.occupazioneBySituazioneAndSettore[
        `${situazioneLavorativa}_${settore}`
      ] || ''
  }

  if (occupazioneBySituazioneAndSettore) {
    occupazioneBySituazioneAndSettore =
      occupazioneBySituazioneAndSettore[0].value
  }

  const occupazione = trim(
    findomesticDati[occupazioneKey] || occupazioneBySituazioneAndSettore
  )

  const codiceTipoLavoro = findomestic.CodiciTipoLavoro.filter(codice => {
    const isParent1 = situazioneLavorativa === trim(codice.parent_1)
    const isParent2 = settore === trim(codice.parent_2)
    const isDescrizione = occupazione === trim(codice.descrizione)

    return isParent1 && isParent2 && isDescrizione
  })

  return codiceTipoLavoro
}

export const getServizioAssicurativoUid = servizio =>
  `${servizio.id}_${servizio.codice}_${servizio.modalita}_${servizio.tipologia_prodotto}`

export const getServizioByUid = (servizioUid, servizi_assicurativi = []) => {
  const splitted = servizioUid.split('_')
  const id = splitted[0]
  const codice = splitted[1]
  const modalita = splitted[2]
  const tipologiaProdotto = splitted[3]
  return servizi_assicurativi.filter(servizio => {
    if (
      servizio.id === Number(id) &&
      servizio.codice === codice &&
      servizio.modalita === modalita &&
      servizio.tipologia_prodotto === tipologiaProdotto
    ) {
      return true
    }
    return false
  })[0]
}

export const getMensilitaCopertura = (
  servizio,
  ordine,
  financements,
  findomestic
) =>
  // solo per cuori funzionali
  !servizio.vincolo_multiplo_mensilita
    ? []
    : new Array(
        // un elemento per ogni multiplo
        parseInt(
          (getFinanziamentoAssicurato(findomestic, ordine, financements)
            ?.numero_rate ?? 0) / servizio.vincolo_multiplo_mensilita
        )
      )
        // riempie con valore del multiplo
        .fill(servizio.vincolo_multiplo_mensilita)
        // calcola i multipli
        .map((val, index) => val * (index + 1))

export const getCodiceServizioByUid = uid => uid.split('_')[1]
export const getModalitaServizioByUid = uid => uid.split('_')[2]
